// src/components/MainLayout.jsx
import React from 'react';
import Navbar from './Navbar';

export default function MainLayout({ children }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800">
      <Navbar />
      <main className="w-full px-6 py-8">
        {children}
      </main>
    </div>
  );
}